import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { is } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		number: Field<string>;
	};
}

export default function StepIndicator({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const number = Number.parseInt(fields.number.value, 10);
	if (is.nonZeroFalsy(number)) {
		return (
			<ComponentPlaceholder
				componentName="StepIndicator"
				description="Requires a number"
				className={getEditorMargin(params)}
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<p className="relative max-w-col-6 after:absolute after:top-4 after:right-0 after:left-[calc(2rem+4px)] after:-mt-px after:border-t-2 after:border-t-strong">
				<span className="flex size-8 items-center justify-center rounded-full border border-transparent bg-brand font-bold text-inverse">
					{number}
				</span>
			</p>
		</LayoutContainer>
	);
}
StepIndicator.displayName = 'StepIndicator';
